import React from 'react';
import { i18n } from 'config/locales';
import Field from 'components/Form/Field';
import Name from 'components/Form/Name';
import PVQName from 'components/Form/PVQName';
import MaidenName from 'components/Form/MaidenName';
import DateRange from 'components/Form/DateRange';
import Textarea from 'components/Form/Textarea';
import Proptypes from 'prop-types';
import { isFormSF852013, isPVQForm } from 'helpers/form';
import Comments from 'components/Form/Comments';

export default class OtherNameItem extends React.Component {
  constructor(props) {
    super(props);
    this.update = this.update.bind(this);
    this.updateName = this.updateName.bind(this);
    this.updateMaidenName = this.updateMaidenName.bind(this);
    this.updateDatesUsed = this.updateDatesUsed.bind(this);
    this.updateReason = this.updateReason.bind(this);
    this.updateComments = this.updateComments.bind(this);

    this.handleNameError = this.handleNameError.bind(this);
  }

  handleNameError(value, arr) {
    const arr2 = arr.map((err) => ({
      ...err,
      code:
        err.code.indexOf('required') !== -1
          ? `name${err.code.substring(err.code.lastIndexOf('.'))}`
          : err.code,
    }));
    return this.props.onError(value, arr2);
  }

  update(queue) {
    this.props.onUpdate({
      Name: this.props.Name,
      MaidenName: this.props.MaidenName,
      DatesUsed: this.props.DatesUsed,
      Reason: this.props.Reason,
      Comments: this.props.Comments,
      ...queue,
    });
  }

  updateName(values) {
    this.update({
      Name: values,
    });
  }

  updateMaidenName(values) {
    this.update({
      MaidenName: values,
    });
  }

  updateDatesUsed(values) {
    this.update({
      DatesUsed: values,
    });
  }

  updateComments(values) {
    this.update({
      Comments: values,
    });
  }

  updateReason(values) {
    this.update({
      Reason: values,
    });
  }

  render() {
    const { formType, formVersion, requireIdentificationOtherNameExplanation } = this.props;
    const attribute = `List.items[${this.props.$index}].Item`;
    const isPVQ = isPVQForm(formType);

    return isPVQ ? (
      <div className="other-name">
        <Field
          title={i18n.t('identification.pvq.othernames.heading.name')}
          titleSize="h4"
          optional
          filterErrors={Name.requiredErrorsOnly}
          scrollIntoView={this.props.scrollIntoView}
        >
          <PVQName
            name="Name"
            {...this.props.Name}
            aria-label="Provide other name used"
            onUpdate={this.updateName} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleNameError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute={`${attribute}.Name`}
            showLastFirstMiddleNameOrder
            showCheckboxAliasOrNickname
          />
        </Field>

        <Field
          title={i18n.t('identification.pvq.othernames.heading.used')}
          titleSize="h4"
          help="alias.used.help"
          adjustFor="daterange"
          scrollIntoView={this.props.scrollIntoView}
          shrink
          attribute={`${attribute}.DatesUsed`}
        >
          <DateRange
            attribute={`${attribute}.DatesUsed`}
            name="DatesUsed"
            {...this.props.DatesUsed}
            onUpdate={this.updateDatesUsed} // eslint-disable-line @typescript-eslint/unbound-method
            minDateEqualTo
            onError={this.props.onError}
            required={this.props.required}
            hideFromDay
            hideToDay
          />
        </Field>
      </div>
    ) : (
      <div className="other-name">
        <Field
          title={i18n.t('identification.othernames.heading.name')}
          titleSize="h4"
          optional
          filterErrors={Name.requiredErrorsOnly}
          scrollIntoView={this.props.scrollIntoView}
        >
          <Name
            name="Name"
            {...this.props.Name}
            aria-label="Provide other name used"
            onUpdate={this.updateName} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleNameError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute={`${attribute}.Name`}
          />
        </Field>

        <Field
          title={i18n.t('identification.othernames.heading.maiden')}
          titleSize="h4"
          help="alias.maiden.help"
          adjustFor="buttons"
          scrollIntoView={this.props.scrollIntoView}
          shrink
          attribute={`${attribute}.MaidenName`}
        >
          <MaidenName
            attribute={`${attribute}.MaidenName`}
            name="MaidenName"
            required={this.props.required}
            {...this.props.MaidenName}
            onUpdate={this.updateMaidenName} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.props.onError}
          />
        </Field>

        <Field
          title={i18n.t('identification.othernames.heading.used')}
          titleSize="h4"
          help="alias.used.help"
          adjustFor="daterange"
          scrollIntoView={this.props.scrollIntoView}
          shrink
          attribute={`${attribute}.DatesUsed`}
        >
          <DateRange
            attribute={`${attribute}.DatesUsed`}
            name="DatesUsed"
            {...this.props.DatesUsed}
            onUpdate={this.updateDatesUsed} // eslint-disable-line @typescript-eslint/unbound-method
            minDateEqualTo
            onError={this.props.onError}
            required={this.props.required}
            hideFromDay
            hideToDay
          />
        </Field>

        {requireIdentificationOtherNameExplanation && (
          <Field
            title={i18n.t('identification.othernames.heading.reason')}
            titleSize="h4"
            scrollIntoView={this.props.scrollIntoView}
            help="alias.reason.help"
            attribute={`${attribute}.Reason`}
          >
            <Textarea
              attribute={`${attribute}.Reason`}
              name="Reason"
              {...this.props.Reason}
              onUpdate={this.updateReason} // eslint-disable-line @typescript-eslint/unbound-method
              onError={this.props.onError}
              className="reason"
              required={this.props.required}
            />
          </Field>
        )}
        {!isFormSF852013(formType, formVersion) && (
          <Comments
            title={i18n.t('identification.othernames.itemcomment')}
            name="OptionalComment"
            attribute="OptionalComment"
            className="optional-comment"
            {...this.props.Comments}
            onUpdate={this.updateComments}
            required={false}
          />
        )}
      </div>
    );
  }
}

OtherNameItem.defaultProps = {
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
  Comments: {},
  required: false,
};

OtherNameItem.propTypes = {
  requireIdentificationOtherNameExplanation: Proptypes.bool,
  formType: Proptypes.string,
  formVersion: Proptypes.string,
};
